/**
 * ? Change Password Component
 */

// Dependencies
import React, { Fragment, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// MUI Icons
import { VisibilityOff, Visibility } from "@mui/icons-material";

// Axios Component
import Axios from "../../axios/Axios";

// Redux Component
import { showSnackbar } from "../redux/features/appSlice";
import { signout } from "../redux/features/userSlice";
import { LoadingButton } from "@mui/lab";

function ChangePassword() {
  // * Router Variable
  const navigate = useNavigate();

  // * Redux Variable
  const dispatch = useDispatch();

  // * User Id Variable
  const {email_id} = useSelector(state => state.user.user);
  

  // * State Variables
  const [showPassword, setShowPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);

  const [passwords, setPasswords] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [currentPasswordError, setCurrentPasswordError] = useState({
    error: false,
    message: "",
  });
  const [newPasswordError, setNewPasswordError] = useState({
    error: false,
    message: "",
  });
  const [confirmPasswordError, setConfirmPasswordError] = useState({
    error: false,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  // TODO : Fields Validation
  function checkFieldsData() {
    let isFormValid = true;

    if (passwords.current_password.length === 0) {
      setCurrentPasswordError({
        ...currentPasswordError,
        error: true,
        message: "Current Password is required.",
      });
      return !isFormValid;
    }

    if (
      passwords.new_password.length === 0 ||
      passwords.new_password.length > 10
    ) {
      isFormValid = false;

      setNewPasswordError({
        ...newPasswordError,
        error: true,
        message: "New Password is required & must be less than 10 characters.",
      });
    }

    if (passwords.new_password !== passwords.confirm_password) {
      isFormValid = false;

      setConfirmPasswordError({
        ...confirmPasswordError,
        error: true,
        message: "Password doesn't match.",
      });
    }

    return isFormValid;
  }

  // TODO : Pushing User to Logout
  function getUerLoggedOut() {
    sessionStorage.removeItem("user_token");
    sessionStorage.removeItem("user_name");
    sessionStorage.removeItem("user_id");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("email_id");
    sessionStorage.removeItem("first_name");
    sessionStorage.removeItem("last_name");
    dispatch(
      signout({
        username: "",
        userrole: null,
        isLoggedIn: false,
        isAuthenticated: false,
      })
    );
    navigate("/login");
    dispatch(
      showSnackbar({
        message: "Password updated successfully, Please login again !",
        severity: "info",
      })
    );
  }

  // ? API Call : Put Method : Update Password of Admin
  async function handlePasswordsData() {
    try {
      const isDataValid = checkFieldsData();

      if (isDataValid) {
        setLoading(true);
        const data = { 
          current_password: passwords.current_password,
          new_password: passwords.new_password,
          email_id
        };

        const options = {
          method: "put",
          url: "adminlogin/update/adminpassword",
          auth: true,
          data: data,
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );

        if (response.status === 200) {
          setPasswords({
            current_password: "",
            new_password: "",
            confirm_password: "",
          });
          setLoading(false);
          getUerLoggedOut();
          console.log(response);
        }
        // alert("Password changed! Please login again.");
        // getUerLoggedOut();
        // dispatch(
        //   showSnackbar({
        //     message: "Password has been updated !",
        //     severity: "success",
        //   })
        // );
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      if(error.status === 400){
        dispatch(
          showSnackbar({
            message: "Your current password is wrong, Please try again",
            severity: "error",
          })
        );
      }else{
        dispatch(
          showSnackbar({
            message: "Error Occurred! Please try again later.",
            severity: "error",
          })
        );
      }
      
    }
  }

  // * Show Password Function
  function handleClickShowPassword() {
    setShowPassword(!showPassword);
  }

  function handleClickShowCurrentPassword() {
    setCurrentPassword(!currentPassword);
  }

  function handleClickShowConfirmPassword() {
    setConfirmPassword(!confirmPassword);
  }

  // * Show Password Function
  function handleMouseDownPassword(event) {
    event.preventDefault();
    setShowPassword(!showPassword);
  }

  function handleMouseCurrentPassword(event) {
    event.preventDefault();
    setCurrentPassword(!currentPassword);
  }
  function handleMouseConfirmPassword(event) {
    event.preventDefault();
    setConfirmPassword(!confirmPassword);
  }

  return (
    <Fragment>
      {/* Title */}
      <Box
        sx={{
          mt: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box>
          <Typography variant="h5" component="div">
            Change Password
          </Typography>
        </Box>
      </Box>

      {/* Input Fields */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mt: "16px",
        }}
      >
        <Typography variant="p" component="div">
          Current&nbsp;Password&nbsp;<span style={{ color: "red" }}>*</span>
        </Typography>

        <TextField
          type={`${currentPassword ? "type" : "password"}`}
          id="current_password"
          size="small"
          variant="outlined"
          label="Current Password"
          placeholder="********"
          sx={{ width: 500 }}
          value={passwords.current_password}
          onChange={(e) => {
            setCurrentPasswordError({
              ...currentPasswordError,
              error: false,
              message: "",
            });
            setPasswords({ ...passwords, current_password: e.target.value });
          }}
          error={currentPasswordError.error}
          helperText={
            currentPasswordError.error ? currentPasswordError.message : ""
          }
          InputProps={{
            autoComplete: "off",
            endAdornment: (
              <InputAdornment>
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowCurrentPassword}
                  onMouseDown={handleMouseCurrentPassword}
                >
                  {currentPassword ? (
                    <Tooltip title="Hide Password" arrow placement="right">
                      <Visibility />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Show Password" arrow placement="right">
                      <VisibilityOff />
                    </Tooltip>
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mt: "16px",
        }}
      >
        <Typography variant="p" component="div">
          New&nbsp;Password&nbsp;<span style={{ color: "red" }}>*</span>
        </Typography>

        <TextField
          type={`${showPassword ? "type" : "password"}`}
          id="new_password"
          size="small"
          variant="outlined"
          label="New Password"
          placeholder="********"
          sx={{ width: 500 }}
          value={passwords.new_password}
          onChange={(e) => {
            setNewPasswordError({
              ...newPasswordError,
              error: false,
              message: "",
            });
            setPasswords({ ...passwords, new_password: e.target.value });
          }}
          error={newPasswordError.error}
          helperText={newPasswordError.error ? newPasswordError.message : ""}
          InputProps={{
            autoComplete: "off",
            endAdornment: (
              <InputAdornment>
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? (
                    <Tooltip title="Hide Password" arrow placement="right">
                      <Visibility />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Show Password" arrow placement="right">
                      <VisibilityOff />
                    </Tooltip>
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mt: "16px",
        }}
      >
        <Typography variant="p" component="div">
          Confirm&nbsp;Password&nbsp;<span style={{ color: "red" }}>*</span>
        </Typography>

        <TextField
          type={`${confirmPassword ? "type" : "password"}`}
          id="confirm_password"
          size="small"
          variant="outlined"
          label="Confirm Password"
          placeholder="********"
          sx={{ width: 500 }}
          value={passwords.confirm_password}
          onChange={(e) => {
            setConfirmPasswordError({
              ...confirmPasswordError,
              error: false,
              message: "",
            });
            setPasswords({ ...passwords, confirm_password: e.target.value });
          }}
          error={confirmPasswordError.error}
          helperText={
            confirmPasswordError.error ? confirmPasswordError.message : ""
          }
          InputProps={{
            autoComplete: "off",
            endAdornment: (
              <InputAdornment>
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowConfirmPassword}
                  onMouseDown={handleMouseConfirmPassword}
                >
                  {confirmPassword ? (
                    <Tooltip title="Hide Password" arrow placement="right">
                      <Visibility />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Show Password" arrow placement="right">
                      <VisibilityOff />
                    </Tooltip>
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* Buttons */}
      <Box
        sx={{
          mt: "16px",
          mb: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          type="button"
          variant="contained"
          color="inherit"
          sx={{ mr: "16px" }}
          onClick={() => navigate(-1)}
        >
          cancel
        </Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="contained"
          color="primary"
          onClick={handlePasswordsData}
        >
          submit
        </LoadingButton>
      </Box>
    </Fragment>
  );
}

export default ChangePassword;
